import React from 'react'
// import { citys, abbrGetCity } from '$utils/citys'
export const CityContext = React.createContext()
